export function calcularTempoMedio(inicio: Date, fim: Date): string {
    const diffMs = Math.abs(fim.getTime() - inicio.getTime());

    const totalMinutos = Math.floor(diffMs / (1000 * 60));
    const horas = Math.floor(totalMinutos / 60);
    const minutos = totalMinutos % 60;

    if (horas === 0) {
        return `${minutos} min`;
    }

    if (horas === 1) {
        return minutos === 0
            ? `1 hora`
            : `1 hora ${minutos} min`;
    }

    return minutos === 0
        ? `${horas} horas`
        : `${horas} horas ${minutos} min`;
}

export function getHoras(data: Date): string {
    return data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit"
    });
}

// DD/MM/YYYY HH:mm
export function formatDateTimePtBr(date: Date): string {
    return date.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

// DD/MM/YYYY
export function formatDate(date: Date): string {
    return date.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    });
}